import React, {useContext} from "react";
import GlobalContext from "../GlobalContext";
import moment from "moment";

const TableCell = ({dayNumber, dayType, monthType}) => {

  const CONTEXT = useContext(GlobalContext);

  function handleClick(dayType, dayNumber, setSelectedDay) {
    if (dayType !== "normal" && setSelectedDay) {
      setSelectedDay(dayNumber);
    }
  }

  function dayTypeBackgroundClass(dayType) {
    return CONTEXT.EVENT_TYPE[dayType] ? CONTEXT.EVENT_TYPE[dayType].class : "";
  }

  function generateClasses(monthType) {
    let defaultClasses = 'text-center';
    let additionalClasses = "";
    let stylingClasses = "";

    if (["previous", "next"].includes(monthType)) {
      additionalClasses = " text-muted ";
    }

    if (monthType === "current" && moment().date() === dayNumber && moment().month() === CONTEXT.selectedMonth && CONTEXT.selectedYear === moment().year()) {
      additionalClasses = " font-weight-bold text-underline ";
    }

    if (dayType !== "normal") {
      additionalClasses += " cursor-pointer ";
      stylingClasses = " color-text-white ";
    }

    stylingClasses += ` ${dayTypeBackgroundClass(dayType)} `;


    return [defaultClasses, additionalClasses, stylingClasses].join(" ").trim().replace(/\s+/g, ' ');
  }

  function eventTypeColorValue(eventType) {

    return CONTEXT.EVENT_TYPE[eventType] ? CONTEXT.EVENT_TYPE[eventType].color : "#fff";
  }

  // for more than 1 event
  function dayTypeBackground(dayType) {
    return `linear-gradient(to bottom right, ${eventTypeColorValue(dayType[0])} 50%, ${eventTypeColorValue(dayType[1])} 50%)`;
  }

  return (
    <GlobalContext.Consumer>
      {({
          setSelectedDay
        }) => (
        <td
          className={generateClasses(monthType)}
          data-day-number={dayNumber}
          data-day-type={dayType}
          data-month-type={monthType}
          style={Array.isArray(dayType) ? {background: dayTypeBackground(dayType)} : {}}
          onClick={() => handleClick(dayType, dayNumber, setSelectedDay)}
        >
          {dayNumber}
        </td>
      )}
    </GlobalContext.Consumer>
  );
};

export default TableCell;
